import type { Area, Point } from 'src/data';
import type { RootState } from '../../app/store';
import {
  getIdOfAreaIndex,
  getIndexOfArea,
  getIndexOfPoint,
} from '../contentful/contentfulSelectors';

export const selectCurrentAreaId = (state: RootState): string => {
  return state.navigation.currentAreaId;
};

export const selectNextAreaId = (state: RootState): string | null=> {
  const currentAreaIndex = selectCurrentAreaIndex(state);
  const nextAreaIndex = currentAreaIndex - 1;

  if (nextAreaIndex < 0) return null;

  const nextAreaId = getIdOfAreaIndex(nextAreaIndex, state);
  return nextAreaId;
};

export const selectCurrentArea = (state: RootState): Area => {
  const areaId = state.navigation.currentAreaId;
  return state.contentful.areas[areaId];
};

export const selectCurrentAreaIndex = (state: RootState): number => {
  const areaId = selectCurrentAreaId(state);
  return getIndexOfArea(areaId, state);
};

export const selectCurrentPointId = (state: RootState): string | null => {
  return state.navigation.currentPointId;
};

export const selectCurrentPoint = (state: RootState): Point | null => {
  const pointId = selectCurrentPointId(state);
  if (!pointId) return null;

  return state.contentful.points[pointId] || null;
};

export const selectCurrentPointIndex = (state: RootState): number => {
  const areaId = selectCurrentAreaId(state);
  const pointId = selectCurrentPointId(state);

  if (!areaId || !pointId) return -1;

  return getIndexOfPoint(areaId, pointId, state);
};

export const selectSoundEnabled = (state: RootState): boolean => {
  return state.navigation.soundEnabled;
};

export const selectPreventNavigation = (state: RootState): boolean => {
  return state.navigation.cameraTransitioning || state.navigation.audioTransitioning;
};

export const selectCreditsOpen = (state: RootState): boolean => {
  return state.navigation.creditsOpen;
};
